import { render } from "./ExpiredSubscription.vue?vue&type=template&id=b87d90f8&scoped=true"
import script from "./ExpiredSubscription.vue?vue&type=script&lang=js"
export * from "./ExpiredSubscription.vue?vue&type=script&lang=js"

import "./ExpiredSubscription.vue?vue&type=style&index=0&id=b87d90f8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87d90f8"]])

export default __exports__